import {
  Component,
  inject,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  DestroyRef,
  DOCUMENT,
  Renderer2
} from '@angular/core';

import { RouterOutlet, ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { EventsService } from './core/services/events/events.service';
import { StepsService } from './pages/hiring/services/steps/steps.service';
import { TagginService } from './core/services/taggin/taggin.service';
import { SplashScreenRequestsComponent } from './core/components/splash-screen-requests/splash-screen-requests.component';
import { AlertComponent } from './pages/hiring/components/alert/alert.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, SplashScreenRequestsComponent, AlertComponent],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly _events = inject(EventsService);
  private readonly _stepsServices = inject(StepsService);
  private readonly route = inject(ActivatedRoute);
  private readonly gtmService = inject(GoogleTagManagerService);
  private readonly tagginService = inject(TagginService);
  private readonly document = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);
  private readonly renderer = inject(Renderer2);

  @ViewChild('postpaidContainer')
  postpaidContainer!: ElementRef<HTMLDivElement>;

  private resizeObserver?: ResizeObserver;
  private popStateListener?: () => void;

  constructor() {}

  ngOnInit(): void {
    this.gtmService.addGtmToDom();
    this.tagginService.loadScripts();
    this.loadSimRegisterComponent();

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (params) => {
        if (params['typeService'] !== undefined) {
          this._stepsServices.serviceType = params['typeService'];
        }
      },
    });

    const win = this.document.defaultView;
    if (win) {
      win.history.pushState(null, '', win.document.URL);

      this.popStateListener = () => {
        win.history.pushState(null, '', win.document.URL);
      };

      win.addEventListener('popstate', this.popStateListener);
    }
  }

  ngAfterViewInit(): void {
    const win = this.document.defaultView;

    if (win && this.postpaidContainer) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this._events.handleHeightResize(entry.borderBoxSize[0].blockSize);
        }
      });
      this.resizeObserver.observe(this.postpaidContainer.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    const win = this.document.defaultView;
    if (win && this.popStateListener) {
      win.removeEventListener('popstate', this.popStateListener);
    }
  }

  private loadSimRegisterComponent(): void {
    if (!this.document.getElementById('simRegisterScript')) {
      const script = this.renderer.createElement('script');
      this.renderer.setAttribute(script, 'type', 'text/javascript');
      this.renderer.setAttribute(script, 'id', 'simRegisterScript');
      this.renderer.setAttribute(script, 'src', environment.lineRegisterScripts);
      this.renderer.appendChild(this.document.head, script);
    }

    if (!this.document.getElementById('simRegisterStyle')) {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'stylesheet');
      this.renderer.setAttribute(link, 'id', 'simRegisterStyle');
      this.renderer.setAttribute(link, 'href', environment.lineRegisterStyle);
      this.renderer.appendChild(this.document.head, link);
    }
  }
}
